
import { onMounted, ref } from 'vue';
import ConfigRepository from "@/services/ConfigRepository";
import Config from '@/models/config.models'
import { useRoute } from 'vue-router'

export default {

  setup() {
    const route = useRoute();

    const appConfig = ref({} as Config);
    const date = ref(route.query.date as string);

    const loadConfig = () => {
      ConfigRepository.getConfig()
          .then((_) => {
            appConfig.value = _.data;
          });
    };

    onMounted(loadConfig);

    return {
      appConfig,
      loadConfig,
      date
    }
  }
}

